export default {
    rough: 'Rough',
    average: 'Average',
    clean: 'Clean',
    extra_clean: 'Extra clean',
};
